export default __webpack_public_path__ + "static/media/nopromo.6a781582.png";